import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { NumberInput } from '../base/number-input.js';
import styles from './spin.less.js';

class SpinInputFormItem extends Component {
    constructor() {
        super(...arguments);
        this.value = this.props.defaultValue;
        this.handleChange = (value, from, allowDecimal = false, toFixed = 0) => {
            var _a, _b, _c, _d;
            const options = evaluate(this.props.options, {});
            if ((allowDecimal && `${value}`.endsWith('.')) || value === '' || value === (options === null || options === void 0 ? void 0 : options.suffix)) {
                this.value = value;
                if (this.value === '' || value === (options === null || options === void 0 ? void 0 : options.suffix)) {
                    (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, null, from);
                }
                this.forceUpdate();
                return;
            }
            let numberValue = allowDecimal ? parseFloat(`${value}`) : parseInt(`${value}`, 10);
            const base = Math.pow(10, toFixed);
            numberValue = Math.round(numberValue * base) / base;
            (_d = (_c = this.props).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, numberValue, from);
            this.value = numberValue;
            this.forceUpdate();
        };
    }
    render() {
        var _a;
        const { label, tooltip } = this.props;
        const tooltipText = evaluate(tooltip, null);
        const value = evaluate(this.props.value, this.props.value ? undefined : this.value);
        const options = evaluate(this.props.options, {});
        const toFixed = (_a = options === null || options === void 0 ? void 0 : options.toFixed) !== null && _a !== void 0 ? _a : ((options === null || options === void 0 ? void 0 : options.allowDecimal) ? 2 : 0);
        return React.createElement(Tooltip, { title: tooltipText, disabled: !tooltipText, className: styles.wrapper },
            React.createElement(NumberInput, Object.assign({}, options, { value: `${value !== null && value !== void 0 ? value : ''}`, onChange: (v, f) => this.handleChange(v, f, options === null || options === void 0 ? void 0 : options.allowDecimal, toFixed), defaultValue: this.props.defaultValue })),
            label && React.createElement("label", null, label));
    }
}

export { SpinInputFormItem };
//# sourceMappingURL=spin.js.map
